import { Colors, Services, getServicePathToAPI, joinURLPath, reportManagerRecurrentFinalStatuses } from '@sigma-frontend-libs/commons'
import { EReportTaskRecurrentStatus } from '@sigmasms/shared-types'

import { globalErrorHandler, icons, request } from '@/utils'

import { serviceNameViaPoint } from '@/components/services/report-manager/recurrent/utils'

import render from './render'

const pathToAPI = getServicePathToAPI(Services['report-manager/recurrent'])

export default {
  name: 'Toggle',

  props: {
    value: {
      type: Object,
      default: undefined
    }
  },

  data() {
    return {
      loading: false
    }
  },

  computed: {
    isFinalStatus() {
      const status = this.value?.status

      return reportManagerRecurrentFinalStatuses.includes(status)
    },

    disabled() {
      if (this.loading) {
        return true
      }

      const status = this.value?.status
      if (typeof status === 'undefined') {
        return true
      }

      return this.isFinalStatus
    },

    label() {
      const status = this.value?.status

      if (status === EReportTaskRecurrentStatus.active) {
        return this.getTranslate('misc.buttons.pause')
      }

      return this.getTranslate('misc.buttons.resume')
    },
    icon() {
      const status = this.value?.status

      if (status === EReportTaskRecurrentStatus.active) {
        return icons.pause
      }

      return icons.play_arrow
    },
    iconColor() {
      const status = this.value?.status

      if (status === EReportTaskRecurrentStatus.active) {
        return Colors.warning
      }

      return Colors.info
    }
  },

  methods: {
    /**
     * Возвращает следующий статус повторяющегося отчёта по текущему состоянию.
     *
     * @param {string | undefined} status
     * @returns {string}
     */
    getNextStatus(status) {
      if (status === EReportTaskRecurrentStatus.active) {
        return EReportTaskRecurrentStatus.paused
      }

      return EReportTaskRecurrentStatus.active
    },

    /**
     * Обновляет локальную карточку ответом сервера,
     * чтобы иконки и действия не ждали внешнее обновление списка.
     *
     * @param {Record<string, unknown> | undefined} data
     * @returns {void}
     */
    syncLocalValue(data) {
      if (!data || typeof data !== 'object' || !this.value) {
        return
      }

      for (const key in data) {
        this.$set(this.value, key, data[key])
      }
    },

    /**
     * Переключает статус задания и сразу синхронизирует локальную карточку.
     *
     * @returns {Promise<void>}
     */
    async toggle() {
      if (this.disabled || !this.value?.id) {
        return
      }

      try {
        this.loading = true
        const status = this.value?.status
        const payload = { status: this.getNextStatus(status) }
        const data = await request.update(joinURLPath(pathToAPI, this.value.id), { body: payload })
        if (data?.status === payload.status) {
          this.syncLocalValue(data)
          this.addSnackbar({
            text: this.getTranslate(`${serviceNameViaPoint}.snackbars.${payload.status}`),
            type: Colors.success
          })
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
